module.exports = __webpack_public_path__ + "static/img/infoLocationRight.9f44b6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/infoLocationRight.png
// module id = bhbt
// module chunks = 2